export enum ExpressionSource {
  SELECT_EXISTING_COLUMN = 'string:Select existing column',
  INPUT_AMOUNT = 'string:Input amount',
  INPUT_COLUMN_NAME = 'string:Input column name',
}
